import { Protocol } from '../Protocol';

export class FeedMachineStatusProtocol {
  public static readonly GET_MATERIAL_MIXER: string = `${Protocol.YATUNG_API_ROOT}/receipt/material/mixer/top3`;
}
